import { useContext } from 'react';

import { MFMessagesContext } from '../providers/MFMessagesProvider';

export const useMFMessagesContext = () => {
  const context = useContext(MFMessagesContext);

  if (!context) {
    throw new Error('useMFMessagesContext must be used within an MFMessagesProvider');
  }

  return context;
};
